import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    cardContainer: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row"
    },
    avatarWrapper: {
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        height: 100,
        width: 100
    },
    avatarContainer: {
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        height: 100,
        width: 100
    },
    editIconContainer: {
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        zIndex: 10,
        bottom: 0,
        right: 0
    },
    profileInfo: {
        justifyContent: "center",
        flex: 1
    },
    profileHeader: {
        alignItems: "center",
        flexDirection: "row"
    },
    cardContent: {
        alignItems: "center",
        flexDirection: "row"
    },
    avatarImage: {
        height: "100%",
        width: "100%"
    },
    container: {
        flex: 1
    }
});

export default stylesheet;
